/**
 * Copyright © Veeam Software Group GmbH.
 */

import { OauthSmtpServersHosts } from '../enums';

export const shouldResetHostField = (host: string): boolean => (host === OauthSmtpServersHosts.Google) || (host === OauthSmtpServersHosts.Azure);
